import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-m-4" }
const _hoisted_2 = { class: "p-field p-col-4" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  for: "type",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DocumentDetailXMLAForm = _resolveComponent("DocumentDetailXMLAForm")
  const _component_DocumentDetailMondrianForm = _resolveComponent("DocumentDetailMondrianForm")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "full-screen-dialog",
    visible: _ctx.visible,
    modal: false,
    closable: false,
    position: "right",
    baseZIndex: 1,
    autoZIndex: true
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
        start: _withCtx(() => [
          _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.documentDetails.designerDialog.olapDesigner')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary olap-designer-toolbar-button",
            onClick: _ctx.closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.back')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary olap-designer-toolbar-button",
            onClick: _ctx.start
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.start')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
            key: 0,
            class: "kn-progress-spinner"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              id: "type",
              class: "kn-material-input",
              modelValue: _ctx.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = $event)),
              options: _ctx.descriptor.typeOptions,
              optionValue: "value",
              optionDisabled: "disabled"
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t(`documentExecution.documentDetails.designerDialog.${slotProps.value}`)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('documentExecution.documentDetails.designerDialog.templateType')), 1)
          ])
        ])
      ]),
      (_ctx.type === 'xmla')
        ? (_openBlock(), _createBlock(_component_DocumentDetailXMLAForm, {
            key: 1,
            class: "p-m-4",
            xmlModel: _ctx.xmlModel
          }, null, 8, ["xmlModel"]))
        : (_openBlock(), _createBlock(_component_DocumentDetailMondrianForm, {
            key: 2,
            class: "p-m-4",
            sbiExecutionId: _ctx.sbiExecutionId,
            mondrianModel: _ctx.mondrianModel,
            mondrianSchemas: _ctx.mondrianSchemas
          }, null, 8, ["sbiExecutionId", "mondrianModel", "mondrianSchemas"]))
    ]),
    _: 1
  }, 8, ["visible"]))
}